import React from "react"
import { ColorRing } from "react-loader-spinner"

const Loader = () => {
  return (
           <div className="flex items-center justify-center w-full my-20 text-center">
             <ColorRing
               visible={true}
               height="80"
               width="80"
               ariaLabel="blocks-loading"
               wrapperStyle={{}}
               wrapperClass="blocks-wrapper"
               colors={["black"]}
             />
           </div>
  )
}

export default Loader